import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {UrlService} from '../../services/url.service';
import {StripeAccountsService} from '../../services/stripe-accounts.service';
import { ActivatedRoute } from '@angular/router';
import { IStripeAccount } from '../../types/api-response/stripe-account';

@Component({
    templateUrl: 'stripe-accounts.component.html',
})
export class StripeAccountsComponent implements OnInit, OnDestroy {

    stripeAccounts: IStripeAccount[] = [];
    filterItems: {id: string|number, name: string}[] = [];

    constructor(
        public stripeAccountsService: StripeAccountsService,
        public urlService: UrlService,
        private route: ActivatedRoute
    ) {}

    ngOnInit() {
        this.stripeAccounts = this.route.snapshot.data.stripeAccounts;
        this.filterItems = this.stripeAccounts.map(account => ({id: account.id, name: account.stripeAccountName || account.id}));

        this.urlService.onUrlChange.subscribe(params => {
            if(!this.stripeAccountsService.firstTimeLoaded || (this.stripeAccountsService.selectedTab == 'Payouts' && params.tab == 'allStripeTransactions')) {
                this.stripeAccountsService.firstTimeLoaded = true;
                this.urlService.queryParams['hasPayout'] = '0';
            }

            this.stripeAccountsService.tabId = this.urlService.queryParams.tab;
            this.stripeAccountsService.selectedTab = this.urlService.queryParams.tab == 'allStripeTransactions' ? 'Transactions' : 'Payouts';

            if(this.urlService.queryParams.accountId) {
                this.stripeAccountsService.selectedStripeAccountId = this.urlService.queryParams.accountId;
            }

            if(this.stripeAccountsService.selectedStripeAccountId) {
                this.stripeAccountsService.getData();
                this.stripeAccountsService.getStripeBalance();
            }

            if(this.stripeAccountsService.tabId != 'allStripeTransactions') {
                this.stripeAccountsService.showDetailedView = false;
                this.urlService.queryParams['hasPayout'] = null;
                this.urlService.queryParams['periodStartDate'] = null;
                this.urlService.queryParams['periodEndDate'] = null;
                this.stripeAccountsService.selectedItems = [];
            }
        });

        this.stripeAccountsService.onStripeAccountSelected.subscribe(() => {
            this.stripeAccountsService.getData();
            this.stripeAccountsService.getStripeBalance();
        });

        this.urlService.queryParams.accountId = this.stripeAccounts[0].id;
        this.urlService.queryParams.hasPayout = '0';
        this.urlService.setQueryParams('allStripeTransactions');

        this.stripeAccountsService.onStripeBalanceReceived.subscribe(
            value => this.stripeAccountsService.availableBalance = value
        );
    }

    ngOnDestroy() {
        this.removeAllObservers();
        this.stripeAccountsService.resetData();
        this.urlService.resetQueryParams();
    }

    removeAllObservers() {
        this.urlService.onUrlChange.observers = [];
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.stripeAccountsService.emptyRowService.fillEmptyRow();
    }
}





// WEBPACK FOOTER //
// /app/src/app/views/stripe-accounts/stripe-accounts.component.ts